import Swal from 'sweetalert2';
import { IArquivoCardEsteira } from '../interfaces/IArquivoCardEsteira';
import { IAgrupadoPorConta, IArquivoEsteira, IDetalhesAviso, IDetalhesConciliado, IDetalhesErro, IDetalhesMatch, IDetalhesPendente, IDetalhesRecomendacao, IEcd, IEntries, ILancamento, IMemoriaCalculo, IRelatorio, IResumo } from "../interfaces/IRelatorio";
import { IEsteira } from "../interfaces/IRelatorioCliente";
import api from "./Api";
import IRelatorioResumoImportacao from '../interfaces/IRelatorioResumoImportacao';
import { IAssistenteComando, IAssistenteComandoOperacao, IAssistenteMensagemHistorico, IAssistenteMensagemResposta } from '../interfaces/IAssistenteIa';

class RelatoriosService {

  async obterTodosClientes(funcaoSucesso?: (data: IEsteira[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get('Esteira/GetEmpresas');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async obterResumoConstancia(esteiraID: number): Promise<any[]> {
    const { data: result } = await api.get<any[]>(`Relatorio/ResumoConstancia/${esteiraID}`, {
      baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
    });
    return result;
  }

  async obterEmpresasPorClienteID(clienteID: number, funcaoSucesso?: (data: IEsteira[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get(`Empresa?perPage=${400}`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3'
      });

      funcaoSucesso && funcaoSucesso(result.map((item: any) => {
        return {
          ...item,
          empresaID: item.id
        }
      }));

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async obterEmpresasPorUsuarioID(usuarioID: number, funcaoSucesso?: (data: IEsteira[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get('Empresa', {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3'
      });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }


  async lancarParaProcessamentoConstancia(esteiraID: number, conta: String[], anexos: IArquivoCardEsteira[] | []): Promise<boolean> {
    try {
      await api.post('ProcessamentoConta/Constancia', {
        conta,
        esteiraID,
        anexos
      }, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return true;
    } catch (error: any) {
      return false;
    }
  }

  async lancarParaProcessamento(esteiraID: number, conta: String[], anexos: IArquivoCardEsteira[] | [], clienteFornecedor: boolean, cartoes: number[]): Promise<boolean> {
    try {
      if (clienteFornecedor) {
        await api.post(`Lancamento/processar/${esteiraID}`, cartoes, {
          baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });
      } else {
        await api.post('ProcessamentoConta', {
          conta: cartoes,
          esteiraID,
          anexos
        }, {
          baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });
      }


      return true;
    } catch (error: any) {
      return false;
    }
  }

  async lancarParaProcessamentoTributos(esteiraID: number, idCartao: number): Promise<boolean> {
    try {
      await api.post(`Lancamento/processar/esteira/${esteiraID}/cartao/${idCartao}/tributos`, {}, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });


      return true;
    } catch (error: any) {
      return false;
    }
  }

  async movimentarStatus(esteiraID: number, de: string, para: string, grupo: string, tipoConta: string = 'padrao'): Promise<any> {
    try {
      await api.patch(`cartao/${esteiraID}/status/${de}/${para}/${grupo}/${tipoConta}`, null, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });
      return null;
    } catch (error: any) {
      return error;
    }
  }

  async movimentarStatusConstancia(esteiraID: number, de: string, para: string): Promise<any> {
    try {
      await api.post(`ProcessamentoConta/MoverStatus/Constancia/${esteiraID}/${de}/${para}`, {}, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return null;
    } catch (error: any) {
      return error;
    }
  }

  async processarSmart(esteiraID: number, cartaoId: number, tipo: string): Promise<boolean> {
    try {
      await api.post(`Conciliation/${esteiraID}/${cartaoId}/smart/${tipo}`, null, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return true;
    } catch (error: any) {
      return false;
    }
  }

  async enviarMensagemAssistente(esteiraID: number, mensagem: string, historicoConversa: IAssistenteMensagemHistorico[]): Promise<IAssistenteMensagemResposta | null> {
    try {
      const { data: result } = await api.post(`AssistenteIa/${esteiraID}/mensagem`, {
        mensagem,
        historicoConversa
      }, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return result;
    } catch (error: any) {
      return null;
    }
  }

  // DEVN3-609: comandos do assistente (custo confirmado pelo usuário antes de rodar).
  async listarComandosAssistente(esteiraID: number): Promise<IAssistenteComando[]> {
    try {
      const { data: result } = await api.get(`AssistenteIa/${esteiraID}/comandos`, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return result ?? [];
    } catch (error: any) {
      return [];
    }
  }

  async obterComandoAssistente(esteiraID: number, comandoId: number): Promise<IAssistenteComando | null> {
    try {
      const { data: result } = await api.get(`AssistenteIa/${esteiraID}/comandos/${comandoId}`, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return result;
    } catch (error: any) {
      return null;
    }
  }

  // acao: 'confirmar' | 'cancelar' | 'aplicar-regras'
  // cartaoIds: só em 'aplicar-regras' — contas do plano a aplicar (ausente = todas).
  async acaoComandoAssistente(esteiraID: number, comandoId: number, acao: 'confirmar' | 'cancelar' | 'aplicar-regras', cartaoIds?: number[]): Promise<IAssistenteComandoOperacao | null> {
    try {
      const { data: result } = await api.post(`AssistenteIa/${esteiraID}/comandos/${comandoId}/${acao}`, cartaoIds ? { cartaoIds } : {}, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return result;
    } catch (error: any) {
      return error?.response?.data ?? null;
    }
  }

  async processarMultiplos(esteiraID: number, conta: number[], valor: boolean, simples: boolean): Promise<boolean> {
    try {
      await api.post(`ProcessamentoConta/multiplos/${valor}/${simples}`, {
        conta,
        esteiraID,
        anexos: []
      }, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return true;
    } catch (error: any) {
      return false;
    }
  }

  async processarMultiplosMatch(esteiraID: number, conta: String): Promise<boolean> {
    try {
      await api.post(`Match/MatchSimples/${esteiraID}/${conta}`, null, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return true;
    } catch (error: any) {
      return false;
    }
  }

  async excluirCliente(id: number, funcaoSucesso?: (data: IResumo) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.delete(`Esteira/ExcluirPorEmpresaID/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async dadosDashboard(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IResumo) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/Resumo', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }


  async todosDadosResumidos(id: number, dataInicio: Date, dataFinal: Date, offset: number, funcaoSucesso?: (data: IRelatorio[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      ;
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        offset
      }
      const { data: result } = await api.post('Relatorio/TodosDadosResumidos', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async buscarCartao(esteiraID: number, conta: string, funcaoSucesso?: (data: IRelatorio) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IRelatorio>(`Relatorio/BuscarCartao/${esteiraID}/${conta}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async buscarCartaoPorFiltro(esteiraID: number, filtro: string, contaResultado: boolean, funcaoSucesso?: (data: IRelatorio[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    const { data: result } = await api.get<IRelatorio[]>(`Cartao/BuscarCartoes/${esteiraID}/${filtro}/${contaResultado}`);

    funcaoSucesso && funcaoSucesso(result);

    textoPopupSucesso && Swal.fire({
      text: textoPopupSucesso,
      timer: 3000,
      icon: 'success',
      showConfirmButton: false
    });

    return true;
  }

  async buscarCartaoPorFiltroCorreto(esteiraID: number, filtro: string, contaResultado: boolean): Promise<IRelatorio[]> {
    const { data: result } = await api.get<IRelatorio[]>(`Cartao/BuscarCartoes/${esteiraID}/${filtro}/${contaResultado}`);
    return result;
  }


  async buscarCartoes(esteiraID: number, status: String, offset: number, contasResultado: boolean, funcaoSucesso?: (data: IRelatorio[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IRelatorio[]>(`Cartao/${esteiraID}?status=${status}&offset=${offset}&tipo=${contasResultado ? "resultado" : "padrao"}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async buscarTodosCartoesNovo(esteiraID: number, status: String, offset: number, contasResultado: boolean): Promise<IRelatorio[]> {
    try {
      const { data: result } = await api.get<IRelatorio[]>(`Cartao/${esteiraID}?status=${status}&offset=${offset}&tipo=${contasResultado ? "resultado" : "padrao"}`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return [];
    }
  }

  async arquivosEsteira(esteiraID: number): Promise<IArquivoEsteira[]> {
    try {
      const { data: result } = await api.get<IArquivoEsteira[]>(`Esteira/${esteiraID}/files`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return [];
    }
  }

  async dadosResumidos(id: number, dataInicio: Date, dataFinal: Date, offset: number, funcaoSucesso?: (data: IRelatorio[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      ;
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        offset
      }
      const { data: result } = await api.post('Relatorio/DadosResumidos', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async buscarPossivelMatch(id: number): Promise<ILancamento[]> {
    const { data: result } = await api.get<ILancamento[]>(`Lancamento/buscar-possivel-match/${id}`);
    return result;
  }

  async relatorioResumoImportacao(): Promise<IRelatorioResumoImportacao[]> {
    const { data: result } = await api.get<IRelatorioResumoImportacao[]>("relatorio/RelatorioResumoImportacao");
    return result;
  }

  async dadosResumidosPorStatusInterno(esteiraID: number, idCartao: number, offset: number, status: string, filter: string, diference: boolean, funcaoSucesso?: (data: IEntries[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get(`Lancamento/${esteiraID}/${idCartao}/${status}?offset=${offset}&perPage=${50}&q=${filter}&diference=${diference}`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async dadosResumidosPorConta(id: number, dataInicio: Date, dataFinal: Date, contas: string[], funcaoSucesso?: (data: IRelatorio[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      ;
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        contas
      }
      const { data: result } = await api.post('Relatorio/DadosResumidosPorConta', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async dadosEcd(id: number, funcaoSucesso?: (data: IEcd[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      // const param = {
      //   empresaId: id,
      //   inicio: new Date(dataInicio).toISOString().substring(0, 10),
      //   fim: new Date(dataFinal).toISOString().substring(0, 10)
      // }
      const { data: result } = await api.get(`Arquivo/GetECDsByEmpresaID/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async agrupadoPorConta(id: number, dataInicio: Date, dataFinal: Date, contaEmpresa: string, funcaoSucesso?: (data: IAgrupadoPorConta) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toJSON().split("T")[0],
        fim: new Date(dataFinal).toJSON().split("T")[0],
        contaEmpresa: contaEmpresa
      }
      const { data: result } = await api.get(`Cartao/detalhes/${id}/${contaEmpresa}/contador`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesErros(id: number, codigoEmpresa: String, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesErro[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        codigoEmpresa
      }
      const { data: result } = await api.post('Relatorio/DetalhesErros', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesAvisos(id: number, codigoEmpresa: String, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesAviso[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        codigoEmpresa
      }
      const { data: result } = await api.post('Relatorio/DetalhesAvisos', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesRecomendacoes(id: number, codigoEmpresa: String, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesRecomendacao[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        codigoEmpresa
      }
      const { data: result } = await api.post('Relatorio/DetalhesRecomendacoes', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesPendentes(id: number, codigoEmpresa: String, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesPendente[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        codigoEmpresa
      }
      const { data: result } = await api.post('Relatorio/DetalhesPendentes', param);

      result.forEach((x: IDetalhesPendente, index: number) => x.id = index);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesConciliados(id: number, codigoEmpresa: String, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesConciliado) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        codigoEmpresa: codigoEmpresa.toString()
      }
      const { data: result } = await api.post('Relatorio/DetalhesConciliados', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async detalhesMatches(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: IDetalhesMatch) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/DetalhesMatches', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async memoriaCalculo(id: number, funcaoSucesso?: (data: IMemoriaCalculo[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get(`Relatorio/MemoriaCalculo/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async memoriaCalculoAlgoritimoConstancia(id: number, funcaoSucesso?: (data: IMemoriaCalculo[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get(`Relatorio/MemoriaCalculoAlgoritimoConstancia/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }
  async pegarUrlImpressao(id: number, listaContaEmpresa: string[], dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: string[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        contasEmpresa: listaContaEmpresa,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/Impressao', param);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async pedirRelatorioImpressaoLancamentos(esteira: number, conta: string): Promise<void> {
    await api.post(`Relatorio/ImprimirTodosLancamentosConta/${esteira}/${conta}`, null, {
      baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
    });
  }

  async pegarUrlImpressaoNovo(id: number, listaContaEmpresa: any[], mostrarContaReferencial: boolean, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: Blob) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        contasEmpresa: listaContaEmpresa.map((item) => {
          return {
            Conta: item.conta,
            Id: item.id
          }
        }),
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10),
        mostrarContaReferencial: mostrarContaReferencial
      }
      const { data: result } = await api.post<Blob>('Relatorio/Impressao', param, { responseType: 'blob' });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }


  async impressaoTodos(id: number, mostrarContaReferencial: boolean, semMovimentacao: boolean, ignorarContasSemPorcento: boolean, grupo: string, status: string, funcaoSucesso?: (data: any) => void): Promise<boolean> {
    try {
      const { data: result } = await api.post(`Relatorio/ImpressaoTodos/${id}/${mostrarContaReferencial}/${semMovimentacao}/${ignorarContasSemPorcento}/${grupo || null}/${status}`, null, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });

      funcaoSucesso && funcaoSucesso(result);

      Swal.fire({
        text: 'Após finalizado o processamento será enviado um e-mail com o arquivo pdf.',
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async atualizarDescricaoConta(esteiraID: number, conta: string, description: string): Promise<void> {
    try {
      await api.patch(`Cartao/${esteiraID}/${conta}/descricao`, {
        descricao: description
      });
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
    }
  }

  async updateStatusConta(conta: String, esteira: Number, status: String): Promise<void> {
    await api.put(`Conta/update/status/${esteira}/${conta}/${status}`);
  }

  async newStatusConta(id: Number, esteira: Number, status: String): Promise<void> {
    await api.patch(`Cartao/${id}/movimentar/${status}`, null, {
      baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
    });
  }

  async buscarPorcentagemConta(conta: String, esteira: Number): Promise<string> {
    const { data: result } = await api.get<string>(`Conta/porcentagem/${esteira}/${conta}`);
    return result;
  }

  async resetarConta(conta: String, esteira: Number): Promise<void> {
    api.post(`Conta/resetar/${esteira}/${conta}`);
  }

  async exportarTodosExcel(id: number, dataInicio: Date, dataFinal: Date, funcaoSucesso?: (data: string[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const param = {
        empresaId: id,
        inicio: new Date(dataInicio).toISOString().substring(0, 10),
        fim: new Date(dataFinal).toISOString().substring(0, 10)
      }
      const { data: result } = await api.post('Relatorio/GerarExcel', param, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async buscarDadosResumoConstancia(esteiraID: number, conta: string): Promise<any> {
    const { data: resultado } = await api.get(`Relatorio/DadosResumoConstancia/${esteiraID}/${conta}`);
    return resultado;
  }

  async buscarDadosRelatorioVerfical(esteiraID: number): Promise<any> {
    const { data: resultado } = await api.get(`Relatorio/BuscarDashboardVerticalRelatorios/${esteiraID}`, {
      baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
    });
    return resultado;
  }

  async exportaTodosLancamentos(esteiraID: number): Promise<void> {
    await api.get(`Relatorio/ExportarLancamentos/${esteiraID}`, {
      baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
    });
  }

  async conciliar(esteiraId: number, cartaoId: number): Promise<boolean> {
    try {
      await api.post(`Conciliation/${esteiraId}/${cartaoId}`, null, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });
      return true;
    } catch (error: any) {
      return false;
    }
  }
}

export default new RelatoriosService();